import { render, staticRenderFns } from "./display-mode-value.vue?vue&type=template&id=4d31f9b8&"
import script from "./display-mode-value.vue?vue&type=script&lang=js&"
export * from "./display-mode-value.vue?vue&type=script&lang=js&"
import style0 from "./display-mode-value.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports